import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news18_1 from "../../images/news/news18_1.jpg";
import news18_2 from "../../images/news/news18_2.jpg";
import news18_3 from "../../images/news/news18_3.jpg";
import news18_4 from "../../images/news/news18_4.jpg";
import news18_5 from "../../images/news/news18_5.jpg";
import news18_6 from "../../images/news/news18_6.jpg";
import news18_7 from "../../images/news/news18_7.jpg";
import news18_8 from "../../images/news/news18_8.jpg";
import news18_9 from "../../images/news/news18_9.jpg";

import { withTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

class news18 extends Component {
    componentDidMount() {}

    componentWillMount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("News18_Title");
    }

    componentWillUnmount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("Home_Title");
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <Header />

                <div className="page-content">
                    <div
                        className="page-banner ovbl-dark"
                        style={{ backgroundImage: "url(" + bannerImg + ")" }}
                    >
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">{t("News18_Title")}</h1>
                            </div>
                        </div>
                    </div>

                    <div className="breadcrumb-row">
                        <div className="container">
                            <ul className="list-inline">
                                <li>
                                    <Link to="/">{t("News18_LinkHome")}</Link>
                                </li>
                                <li>{t("News18_LinkCourses")}</li>
                            </ul>
                        </div>
                    </div>

                    <div className="content-block">
                        <div className="section-area section-sp1">
                            <div className="container">
                                <div className="row d-flex flex-row-reverse">
                                    <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
                                        <div className="courses-post">

                                            <h1>{t("News18_Content_H")}</h1>

                                            {/* P1 */}
                                            <ReactMarkdown>{t("News18_P1_MD")}</ReactMarkdown>

                                            {/* IMG 1 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news18_1}
                                                    alt={t("News18_IMG1_DESC")}
                                                    width={"60%"}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News18_IMG1_DESC")}
                                                </div>
                                            </div>

                                            {/* P2 */}
                                            <ReactMarkdown>{t("News18_P2_MD")}</ReactMarkdown>

                                            {/* IMG 2 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news18_2}
                                                    alt={t("News18_IMG2_DESC")}
                                                    width={"60%"}

                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News18_IMG2_DESC")}
                                                </div>
                                            </div>

                                            {/* P3 */}
                                            <ReactMarkdown>{t("News18_P3_MD")}</ReactMarkdown>

                                            {/* IMG 3 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news18_3}
                                                    alt={t("News18_IMG3_DESC")}
                                                    width={"60%"}

                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News18_IMG3_DESC")}
                                                </div>
                                            </div>

                                            {/* P4 */}
                                            <ReactMarkdown>{t("News18_P4_MD")}</ReactMarkdown>

                                            {/* IMG 4 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news18_4}
                                                    alt={t("News18_IMG4_DESC")}
                                                    width={"60%"}

                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News18_IMG4_DESC")}
                                                </div>
                                            </div>

                                            {/* P5 */}
                                            <ReactMarkdown>{t("News18_P5_MD")}</ReactMarkdown>

                                            {/* IMG 5 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news18_5}
                                                    alt={t("News18_IMG5_DESC")}
                                                    width={"60%"}

                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News18_IMG5_DESC")}
                                                </div>
                                            </div>

                                            {/* P6 */}
                                            <ReactMarkdown>{t("News18_P6_MD")}</ReactMarkdown>

                                            {/* IMG 6 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news18_6}
                                                    alt={t("News18_IMG6_DESC")}
                                                    width={"60%"}

                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News18_IMG6_DESC")}
                                                </div>
                                            </div>

                                            {/* P7 */}
                                            <ReactMarkdown>{t("News18_P7_MD")}</ReactMarkdown>


                                            {/* IMG 7 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news18_7}
                                                    alt={t("News18_IMG7_DESC")}
                                                    width={"60%"}

                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News18_IMG7_DESC")}
                                                </div>
                                            </div>

                                            {/* P8 */}
                                            <ReactMarkdown>{t("News18_P8_MD")}</ReactMarkdown>

                                            {/* IMG 8 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news18_8}
                                                    alt={t("News18_IMG8_DESC")}
                                                    width={"60%"}

                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News18_IMG8_DESC")}
                                                </div>
                                            </div>

                                            {/* P9 */}
                                            <ReactMarkdown>{t("News18_P9_MD")}</ReactMarkdown>

                                            {/* IMG 9 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news18_9}
                                                    alt={t("News18_IMG9_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News18_IMG9_DESC")}
                                                </div>
                                            </div>

                                            {/* P10 */}
                                            <ReactMarkdown>{t("News18_P10_MD")}</ReactMarkdown>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </>
        );
    }
}

export default news18 = withTranslation()(news18);
